import { usePrivy } from '@privy-io/react-auth';
import { useContext, useEffect } from 'react';
import OneSignal from 'react-onesignal';
import { NotificationContext } from '../providers/NotificationProvider';

export const useNotification = (promptReminder?: boolean) => {
  const { user } = usePrivy();
  const { showReminder } = useContext(NotificationContext);

  useEffect(() => {
    if (!promptReminder) return;
    const mobileUserAgentRegex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    if (
      window.matchMedia('(display-mode: standalone)').matches ||
      !mobileUserAgentRegex.test(navigator.userAgent)
    ) {
      // skip reminder if not enabled
      const enabled = process.env.REACT_APP_NOTIFICATION_ENABLED;
      if (enabled !== 'true') return;
      // is pwa, check for notification popup
      setTimeout(() => {
        const isPushSupported = OneSignal.Notifications.isPushSupported();
        if (isPushSupported) {
          // check notification
          let permission =
            Notification.permission === 'granted' ||
            !!OneSignal.Notifications.permission ||
            OneSignal.Notifications.permissionNative === 'granted';
          if (!permission) showReminder('notification');
        }
      }, 3000);
    } else {
      // show pwa popup
      showReminder('pwa');
    }
  }, [promptReminder]);

  const loginOneSignal = async () => {
    if (!!user?.id) {
      await OneSignal.login(user?.id.toString() ?? '');
    }
  };

  useEffect(() => {
    loginOneSignal();
  }, [user?.id]);
};
